// extracted by mini-css-extract-plugin
export default {"svg":"MessageNode_svg__qm97g","placeholder":"MessageNode_placeholder__j3ADW","deleteIcon":"MessageNode_deleteIcon__l9dGg"};